import Vue from 'vue';
import VueRouter from 'vue-router';
import Admin from '../views/Admin.vue';
import Customers from '../views/Customers.vue';
import ApiPolicy from '../views/ApiPolicy.vue';
import Domain from '../views/Domain.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Admin',
    component: Admin
  },
  {
    path: '/customers',
    name: 'Customers',
    component: Customers
  },
  {
    path: '/api-policy',
    name: 'ApiPolicy',
    component: ApiPolicy
  },
  {
    path: '/domain',
    name: 'Domain',
    component: Domain
  }
];

const router = new VueRouter({
  routes
});

export default router;
